import React from 'react';
import { Field, Modal } from '../../components/ui';
import { yesNo, activeOptions } from './useUserManagement';

// Add/Edit user modal — mobile (full-screen, single column) variant.
export default function UserEditFormMobile({ vm }) {
  const { editing, form, setF, saving, close, save } = vm;
  return (
    <Modal
      fullScreen
      title={editing ? 'Edit User' : 'Add User'}
      onClose={close}
      footer={<>
        <button className="btn light" onClick={close}>Cancel</button>
        <button className="btn primary" disabled={saving} onClick={save}>{saving ? 'Saving...' : 'Save'}</button>
      </>}
    >
      <div className="form-grid" style={{ gridTemplateColumns: '1fr' }}>
        <Field label="Surname" value={form.Surname} onChange={v => setF('Surname', v)} />
        <Field label="Name" value={form.Name} required onChange={v => setF('Name', v)} />
        <Field label="Father / Husband" value={form.FatherHusband} onChange={v => setF('FatherHusband', v)} />
        <Field label="Mobile Number" value={form.MobileNumber} required onChange={v => setF('MobileNumber', v)} />
        <Field label="Email" value={form.EmailId} onChange={v => setF('EmailId', v)} />
        <Field label={editing ? 'New Password' : 'Password'} type="password" value={form.Password} required={!editing} onChange={v => setF('Password', v)} />
        <Field label="Super Admin" type="select" value={form.SuperAdmin} options={yesNo} onChange={v => setF('SuperAdmin', v)} />
        <Field label="Allow Mobile Login" type="select" value={form.AllowUserMobile} options={yesNo} onChange={v => setF('AllowUserMobile', v)} />
        <Field label="Status" type="select" value={form.IsActive} options={activeOptions} onChange={v => setF('IsActive', v)} />
      </div>
    </Modal>
  );
}
